import Vue from 'vue'
import moment from 'moment'

Vue.filter('toDate', value => {
  if (!value) return ''
  return moment(value, 'YYYY-MM-DD HH:mm').locale('uk').format('ll')
})

Vue.filter('countYears', value => {
  if (!value) return ''
  return moment().diff(value, 'years')
})

Vue.filter('normalizeData', data => {
  data.forEach((item, i) => {
    item.text = item.name
    item.value = item.id
  })

  return data
})



// WEBPACK FOOTER //
// ./src/filters/index.js